import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Zap, ArrowLeft, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B0F19]">
      <div className="relative hidden lg:flex flex-col justify-between p-12 grid-bg overflow-hidden">
        <div className="aurora" />
        <Link to="/" className="relative z-10 flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 to-indigo-500 flex items-center justify-center">
            <Zap className="w-5 h-5 text-slate-950" fill="currentColor" />
          </div>
          <span className="font-display font-extrabold text-lg text-slate-50">NexxVibe</span>
        </Link>
        <div className="relative z-10">
          <h1 className="font-display text-4xl font-extrabold text-slate-50 leading-tight mb-4">Stop guessing<br />what to build.</h1>
          <p className="text-slate-400 max-w-md">Discover, validate, and build better software opportunities with AI-powered builder intelligence. Join thousands of builders finding their next profitable product.</p>
        </div>
        <p className="relative z-10 text-xs text-slate-600 font-mono">The Bloomberg Terminal for Software Opportunities</p>
      </div>

      <div className="flex flex-col items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 text-slate-500 text-sm mb-8"><ArrowLeft className="w-4 h-4" />Back home</Link>
          <div className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center mb-6 glow-cyan">
            <Zap className="w-6 h-6 text-cyan-400" />
          </div>
          <h2 className="font-display text-2xl font-bold text-slate-50 mb-2">Welcome to NexxVibe</h2>
          <p className="text-slate-400 text-sm mb-4">Sign in to start discovering opportunities and building smarter.</p>
          <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-xs font-semibold mb-6" data-testid="login-free-badge">
            <Check className="w-3.5 h-3.5" />100% free forever — no credit card
          </div>
          <Button onClick={login} data-testid="google-login-btn"
            className="w-full h-11 bg-white text-slate-900 hover:bg-slate-100 font-semibold gap-3">
            <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </Button>
          <p className="text-xs text-slate-600 text-center mt-6">By continuing you agree to our Terms & Privacy Policy.</p>
        </div>
      </div>
    </div>
  );
}
